module.exports = __webpack_public_path__ + "img/alabama-power-logo.133af7f1.jpg";